<template>
	<v-flex xs12>
		<v-card>
			<v-card-title>
				<v-flex xs12 class="mb-5">
					<h4>{{ pageTitle }}</h4>
				</v-flex>
				<v-flex xs12>
					<v-form ref="form" lazy-validation @submit.prevent="submit">
						<v-simple-table fixed-header height="300px">
							<template v-slot:default>
								<thead>
									<tr>
										<th class="text-left">Question</th>
										<th class="text-left">Answer</th>
										<th class="text-left">Action</th>
									</tr>
								</thead>

								<tbody>
									<tr v-for="(item, index) in faqs" :key="index">
										<td>
											<v-textarea
												clearable
												clear-icon="cancel"
												rows="1"
												:counter="1000"
												label="Question"
												:rules="[
													(v) => !!v || 'Question is required',
													(v) =>
														(v && v.length <= 1000) ||
														'Question must not be greater than 1000 characters',
												]"
												v-bind:name="'question' + index"
												v-bind:id="'question' + index"
												required
												:value="item.question"
												v-on:keyup.stop="
													updateField('question', $event.target.value, index)
												"
											></v-textarea>
										</td>
										<td>
											<v-textarea
												clearable
												clear-icon="cancel"
												rows="1"
												:counter="5000"
												:rules="[
													(v) => !!v || 'Answer is required',
													(v) =>
														(v && v.length <= 5000) ||
														'Answer must not be greater than 5000 characters',
												]"
												label="Answer"
												v-bind:name="'answer' + index"
												v-bind:id="'answer' + index"
												:value="item.answer"
												required
												v-on:keyup.stop="
													updateField('answer', $event.target.value, index)
												"
											></v-textarea>
										</td>
										<td>
											<v-icon
												v-if="index == faqs.length - 1"
												small
												@click="addFaq()"
												>add</v-icon
											>
											<v-icon v-else small @click="deleteFaq(item)"
												>delete</v-icon
											>
										</td>
									</tr>
								</tbody>
							</template>
						</v-simple-table>

						<v-divider class="mt-5"></v-divider>
						<v-card-actions>
							<v-btn color="success" type="submit">
								<v-icon>save</v-icon>Save
							</v-btn>
							<v-btn color="error" @click="reset">Reset</v-btn>
						</v-card-actions>
					</v-form>
				</v-flex>
			</v-card-title>
		</v-card>
	</v-flex>
</template>

<script>
import store from "../../store";
import commonservice from "../../shared/common.service";
import { mapGetters } from "vuex";
export default {
	computed: {
		...mapGetters(["faq/faqs"]),
		faqs: {
			get() {
				return this.$store.state.faq.faqs;
			},
		},
	},
	data() {
		return {
			loading: false,
			pageTitle: "Category FAQ",
		};
	},
	beforeRouteEnter(to, from, next) {
		if (to.params.id) {
			store.dispatch("faq/setFaq", { id: to.params.id }).then(() => {
				next((p) => {
					p.pageTitle = "Category FAQ";
				});
			});
		} else {
			next((p) => {
				p.reset();
			});
		}
	},
	methods: {
		updateField(field, value, index) {
			this.$store.commit("faq/UPDATE_FAQ", { field, value, index });
		},
		submit() {
			if (this.loading) return;

			if (this.$refs.form.validate()) {
				this.loading = true;
				this.$store.dispatch("faq/saveFaq").then(
					() => {
						commonservice.showSuccessMessage("FAQ saved successfully");
						this.$router.push("/category");
						this.loading = false;
					},
					() => {
						this.loading = false;
					}
				);
			}

			/* this.$validator.validateAll().then(valid => {
        if (valid) {
          
        }
      });*/
		},
		addFaq() {
			this.$store.commit("faq/ADD_FAQ");
		},
		deleteFaq(item) {
			this.$store.commit("faq/DELETE_FAQ", item);
		},
		reset() {
			this.$router.push("/category");
		},
	},
};
</script>
